<template>
  <div class="mobile-account-delete-confirm dialog-content" :aria-busy="loading">
    <p class="warning-text">
      <el-icon color="#FF9900" size="large"><Warning /></el-icon>
      <span>{{ $t('views.account_center.delete_warning') }}</span>
    </p>
    <div class="mobile-dialog-step">
      <p>{{ email ? $t('views.account_center.confirm_by_email') : $t('views.account_center.confirm_by_phone') }}</p>
      <p class="mobile-dialog-identity">{{ email || phone }}</p>
    </div>
    <el-input
      data-account-field="delete-confirm"
      :model-value="confirmation"
      type="text"
      autocomplete="off"
      :placeholder="email ? $t('views.account_center.enter_email_confirm') : $t('views.account_center.enter_phone_confirm')"
      :aria-label="email ? $t('views.account_center.enter_email_confirm') : $t('views.account_center.enter_phone_confirm')"
      @update:model-value="$emit('confirmation-change', $event)"
    />
    <div class="mobile-dialog-actions">
      <el-button data-account-action="cancel" @click="$emit('cancel')">{{ $t('common.cancel') }}</el-button>
      <el-button
        data-account-action="delete"
        type="danger"
        :loading="loading"
        :disabled="loading || confirmation !== (email || phone)"
        @click="$emit('confirm')"
      >{{ $t('views.account_center.confirm_delete_account') }}</el-button>
    </div>
  </div>
</template>

<script>
import { Warning } from '@element-plus/icons-vue'

export default {
  name: 'MobileAccountDeleteConfirm',
  components: { Warning },
  props: {
    email: { type: String, default: '' },
    phone: { type: String, default: '' },
    confirmation: { type: String, default: '' },
    loading: Boolean
  },
  emits: ['confirmation-change', 'cancel', 'confirm']
}
</script>
